import { Link } from "react-router-dom";
import VideoCard from "@/components/base/VideoCard";
import { getLatestVideos } from "@/data/videos";

export default function LatestVideos() {
  const videos = getLatestVideos(12);

  return (
    <section className="border-t border-background-200/70 bg-background-100">
      <div className="container-page py-10 md:py-14">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className="ri-upload-cloud-2-line text-lg"></i>
              </span>
              最新上线
            </h2>
            <p className="mt-1 text-sm text-foreground-500">
              刚刚入库的高清视频资源，追新不落后
            </p>
          </div>
          <Link
            to="/search"
            className="hidden cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700 sm:flex"
          >
            浏览全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4 md:gap-5">
          {videos.map((video) => (
            <VideoCard key={video.id} video={video} showCategory />
          ))}
        </div>
      </div>
    </section>
  );
}